import React, { useState } from 'react';
import useReady from '../../Hooks/useReady';
import WallpaperCalculatorModal from '../WallpaperCalculator/WallpaperCalculatorModal';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import { setShowMiniCart } from '../../Actions/Cart.action';
import ProductPageLinkBlock from './ProductPageLinkBlock';
import { translate } from '../../Services/translation';

const ProductPageWallpaperCalculatorModalWrapper = ({
  articleNumber,
  rollWidth,
  rollLength,
  patternSizeMeters,
  fitment,
  hasPrice,
}: {
  articleNumber: string;
  rollWidth: number;
  rollLength: number;
  patternSizeMeters: number;
  fitment: number;
  hasPrice: boolean;
}) => {
  const dispatch = useTypedDispatch();
  const ready = useReady();
  const [wallpaperCalculatorOpen, setWallpaperCalculatorOpen] =
    useState(false);

  return (
    <>
      <ProductPageLinkBlock
        preTitle={translate('product-page.wallpaper-calculator')}
        title={translate('product-page.wallpaper-calculator.title')}
        description={translate(
          'product-page.wallpaper-calculator.description'
        )}
        buttonText={translate('product-page.wallpaper-calculator.button')}
        iconName="scroll"
        onClick={() => setWallpaperCalculatorOpen(true)}
      />
      {ready && (
        <WallpaperCalculatorModal
          open={wallpaperCalculatorOpen}
          onClosed={() => setWallpaperCalculatorOpen(false)}
          rollWidth={rollWidth}
          rollLength={rollLength}
          patternSizeMeters={patternSizeMeters}
          fitment={fitment}
          articleNumber={articleNumber}
          hasPrice={hasPrice}
          onAddedToCart={() => {
            setTimeout(() => {
              setWallpaperCalculatorOpen(false);
              setTimeout(() => {
                dispatch(setShowMiniCart(true));
              }, 1);
            }, 150);
          }}
        />
      )}
    </>
  );
};

export default ProductPageWallpaperCalculatorModalWrapper;
